/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.calendar.bell-schedules'},
});

const BellSchedulesItem = () => (
  <RouteLinkItem
    route="midas/settings/calendar/bell-schedules"
    title={messages.title}
  />
);

export default BellSchedulesItem;
